// import React, { useState } from 'react';
// import {
//   Table,
//   Spinner,
//   Form,
//   Row,
//   Col,
//   Button,
//   Alert,
//   Badge,
//   CardFooter,
//   CardTitle,
//   ProgressBar
// } from 'react-bootstrap';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
// import { Card, CardBody, CardHeader } from '@components/card/card';
// import { ntxAPI } from '@API/axiosNeatex';
// import useGetItemsList from '@hooks/INV/MasterItems/useGetItemsList';
// import Select from 'react-select';
// import { useTranslation } from 'react-i18next';
// import type { APIResponse } from '@store/Shared/shared';

// import Loading from '@components/Shared/Loader/Loading';

// interface InventoryTurnover {
//   itemId: string;
//   itemCode: string;
//   itemName: string;
//   itemName2: string;
//   costOfGoodsSold: number;
//   openingStockValue: number;
//   closingStockValue: number;
//   averageStockValue: number;
//   turnoverRate: number;
// }

// const InventoryTurnoverReport: React.FC = () => {
//   const [data, setData] = useState<InventoryTurnover[]>([]);
//   const [loading, setLoading] = useState<boolean>(false);
//   const [error, setError] = useState<string | null>(null);

//   const { ItemsOptions, loading: loading1, error: error1 } = useGetItemsList();
//   const [itemId, setItemId] = useState<string | null>('');
//   const { t, i18n } = useTranslation();

//   const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([null, null]);
//   const [startDate, endDate] = dateRange;

//   const [turnoverFilter, setTurnoverFilter] = useState<string>('all');
//   const [performanceFilter, setPerformanceFilter] = useState<string>('all');

//   const fetchData = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const { data } = await ntxAPI.get<APIResponse<InventoryTurnover[]>>(`InventoryReports/turnover`, {
//         params: {
//           ItemId: itemId,
//           StartDate: startDate,
//           EndDate: endDate
//         }
//       });

//       if (data.succeeded === true) {
//         setData(data.data);
//       } else {
//         setError(data instanceof Error ? data.message : t('UnknownError'));
//       }
//     } catch (err) {
//       setError(err instanceof Error ? err.message : t('UnknownError'));
//     } finally {
//       setLoading(false);
//     }
//   };

//   const resetFilters = () => {
//     setItemId(null);
//     setDateRange([null, null]);
//     setTurnoverFilter('all');
//     setPerformanceFilter('all');
//   };

//   const formatCurrency = (amount: number): string => {
//     return new Intl.NumberFormat('en-US').format(amount);
//   };
//   const formatTurnoverRate = (rate: number): string => {
//     return rate.toFixed(2);
//   };

//   // Get turnover performance category
//   const getTurnoverPerformance = (turnoverRate: number) => {
//     if (turnoverRate === 0) return { category: 'No Turnover', color: 'secondary', badge: 'secondary' };
//     if (turnoverRate >= 8) return { category: 'Excellent', color: 'success', badge: 'success' };
//     if (turnoverRate >= 4) return { category: 'Good', color: 'info', badge: 'primary' };
//     if (turnoverRate >= 2) return { category: 'Average', color: 'warning', badge: 'warning' };
//     return { category: 'Slow', color: 'danger', badge: 'danger' };
//   };

//   // Get turnover badge color
//   const getTurnoverBadgeColor = (turnoverRate: number) => {
//     if (turnoverRate === 0) return 'secondary';
//     if (turnoverRate >= 8) return 'success';
//     if (turnoverRate >= 4) return 'info';
//     if (turnoverRate >= 2) return 'warning';
//     return 'danger';
//   };

//   // Calculate turnover statistics
//   const calculateTurnoverStats = () => {
//     const totalItems = data.length;
//     const excellentTurnover = data.filter(item => item.turnoverRate >= 8).length;
//     const goodTurnover = data.filter(item => item.turnoverRate >= 4 && item.turnoverRate < 8).length;
//     const averageTurnover = data.filter(item => item.turnoverRate >= 2 && item.turnoverRate < 4).length;
//     const slowTurnover = data.filter(item => item.turnoverRate > 0 && item.turnoverRate < 2).length;
//     const noTurnover = data.filter(item => item.turnoverRate === 0).length;

//     const totalCOGS = data.reduce((sum, item) => sum + item.costOfGoodsSold, 0);
//     const totalAvgStock = data.reduce((sum, item) => sum + item.averageStockValue, 0);
//     const avgTurnoverRate = totalItems > 0 ? data.reduce((sum, item) => sum + item.turnoverRate, 0) / totalItems : 0;

//     return {
//       totalItems,
//       excellentTurnover,
//       goodTurnover,
//       averageTurnover,
//       slowTurnover,
//       noTurnover,
//       totalCOGS,
//       totalAvgStock,
//       avgTurnoverRate
//     };
//   };

//   // Filter data based on turnover and performance
//   const filteredData = data.filter(item => {
//     if (turnoverFilter === 'excellent' && item.turnoverRate < 8) return false;
//     if (turnoverFilter === 'good' && (item.turnoverRate < 4 || item.turnoverRate >= 8)) return false;
//     if (turnoverFilter === 'average' && (item.turnoverRate < 2 || item.turnoverRate >= 4)) return false;
//     if (turnoverFilter === 'slow' && (item.turnoverRate >= 2 || item.turnoverRate === 0)) return false;
//     if (turnoverFilter === 'none' && item.turnoverRate !== 0) return false;

//     if (performanceFilter === 'highValue' && item.averageStockValue < 1000) return false;
//     if (performanceFilter === 'lowValue' && item.averageStockValue >= 1000) return false;

//     return true;
//   });

//   const {
//     totalItems,
//     excellentTurnover,
//     goodTurnover,
//     averageTurnover,
//     slowTurnover,
//     noTurnover,
//     totalCOGS,
//     totalAvgStock,
//     avgTurnoverRate
//   } = calculateTurnoverStats();
//   return (
//     <div className='container mt-4'>
//       <Card>
//         <CardHeader className='d-flex justify-content-between align-items-center'>
//           <h5 className='mb-0'>Inventory Turnover Report</h5>
//           {data.length > 0 && (
//             <div>
//               <span className='me-2'>
//                 Showing: {filteredData.length} of {data.length} items
//               </span>
//             </div>
//           )}
//         </CardHeader>

//         <CardBody>
//           {error && (
//             <Alert variant='danger' className='mb-4'>
//               {i18n.language === 'en' ? 'Error loading data:' : 'خطأ في تحميل البيانات:'} {error}
//             </Alert>
//           )}

//           <Card className='mb-4'>
//             <CardHeader>{i18n.language === 'en' ? 'Filters' : 'الفلاتر'}</CardHeader>
//             <Loading loading={loading1} error={error1}>
//               <CardBody>
//                 <Form>
//                   <Row className='g-3'>
//                     <Col md={3}>
//                       <Form.Group>
//                         <Form.Label>{t('itemName')}</Form.Label>
//                         <Select
//                           classNamePrefix='react-select'
//                           isSearchable
//                           isClearable
//                           options={ItemsOptions}
//                           onChange={(option: any) => setItemId(option?.value || null)}
//                           value={ItemsOptions.find(f => f.value === itemId)}
//                           placeholder={t('Choose')}
//                           menuPortalTarget={document.body}
//                           styles={{
//                             menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
//                           }}
//                         />
//                       </Form.Group>
//                     </Col>

//                     <Col md={3}>
//                       <Form.Group>
//                         <Form.Label>{i18n.language === 'en' ? 'Date Range' : 'نطاق التاريخ'}</Form.Label>
//                         <DatePicker
//                           selectsRange={true}
//                           startDate={startDate}
//                           endDate={endDate}
//                           onChange={update => setDateRange(update)}
//                           isClearable={true}
//                           className='form-control text-center'
//                           placeholderText={i18n.language === 'en' ? 'Select date range' : 'اختر نطاق التاريخ'}
//                         />
//                       </Form.Group>
//                     </Col>

//                     <Col md={3}>
//                       <Form.Group controlId='turnoverFilter'>
//                         <Form.Label>Turnover Rate</Form.Label>
//                         <Form.Select value={turnoverFilter} onChange={e => setTurnoverFilter(e.target.value)}>
//                           <option value='all'>All Turnover Rates</option>
//                           <option value='excellent'>Excellent (8+)</option>
//                           <option value='good'>Good (4-7.99)</option>
//                           <option value='average'>Average (2-3.99)</option>
//                           <option value='slow'>Slow (0.01-1.99)</option>
//                           <option value='none'>No Turnover (0)</option>
//                         </Form.Select>
//                       </Form.Group>
//                     </Col>

//                     <Col md={3}>
//                       <Form.Group controlId='performanceFilter'>
//                         <Form.Label>Stock Value</Form.Label>
//                         <Form.Select value={performanceFilter} onChange={e => setPerformanceFilter(e.target.value)}>
//                           <option value='all'>All Stock Values</option>
//                           <option value='highValue'>High Value (≥ $1,000)</option>
//                           <option value='lowValue'>Low Value (&lt; $1,000)</option>
//                         </Form.Select>
//                       </Form.Group>
//                     </Col>

//                     <Col xs={12} className={`text-end  `}>
//                       <Button variant='secondary' onClick={resetFilters} className='me-2'>
//                         {i18n.language === 'en' ? 'Reset Filters' : 'إعادة تعيين الفلاتر'}
//                       </Button>
//                       <Button variant='primary' onClick={fetchData} disabled={loading}>
//                         {loading ? (
//                           <>
//                             <Spinner
//                               as='span'
//                               animation='border'
//                               size='sm'
//                               role='status'
//                               aria-hidden='true'
//                               className='me-2'
//                             />
//                             {i18n.language === 'en' ? 'Loading...' : 'جاري التحميل...'}
//                           </>
//                         ) : i18n.language === 'en' ? (
//                           'Load Report'
//                         ) : (
//                           'تحميل التقرير'
//                         )}
//                       </Button>
//                     </Col>
//                   </Row>
//                 </Form>
//               </CardBody>
//             </Loading>
//           </Card>

//           {/* Turnover Summary */}
//           {data.length > 0 && (
//             <Row className='mb-4'>
//               <Col md={2}>
//                 <Card className='text-center border-0 bg-secondary bg-opacity-35 '>
//                   <CardBody className='p-3'>
//                     <CardTitle className='fs-6 text-primary'>Total Items</CardTitle>
//                     <h4 className='text-primary'>{totalItems}</h4>
//                   </CardBody>
//                 </Card>
//               </Col>
//               <Col md={2}>
//                 <Card className='text-center border-0 bg-secondary bg-opacity-35 '>
//                   <CardBody className='p-3'>
//                     <CardTitle className='fs-6 text-success'>Excellent</CardTitle>
//                     <h4 className='text-success'>{excellentTurnover}</h4>
//                     <small className='text-muted'>{((excellentTurnover / totalItems) * 100).toFixed(1)}%</small>
//                   </CardBody>
//                 </Card>
//               </Col>
//               <Col md={2}>
//                 <Card className='text-center border-0 bg-secondary bg-opacity-35 '>
//                   <CardBody className='p-3'>
//                     <CardTitle className='fs-6 text-info'>Good</CardTitle>
//                     <h4 className='text-info'>{goodTurnover}</h4>
//                     <small className='text-muted'>{((goodTurnover / totalItems) * 100).toFixed(1)}%</small>
//                   </CardBody>
//                 </Card>
//               </Col>
//               <Col md={2}>
//                 <Card className='text-center border-0 bg-secondary bg-opacity-35 '>
//                   <CardBody className='p-3'>
//                     <CardTitle className='fs-6 text-warning'>Average</CardTitle>
//                     <h4 className='text-warning'>{averageTurnover}</h4>
//                     <small className='text-muted'>{((averageTurnover / totalItems) * 100).toFixed(1)}%</small>
//                   </CardBody>
//                 </Card>
//               </Col>
//               <Col md={2}>
//                 <Card className='text-center border-0 bg-secondary bg-opacity-35 '>
//                   <CardBody className='p-3'>
//                     <CardTitle className='fs-6 text-danger'>Slow</CardTitle>
//                     <h4 className='text-danger'>{slowTurnover}</h4>
//                     <small className='text-muted'>{((slowTurnover / totalItems) * 100).toFixed(1)}%</small>
//                   </CardBody>
//                 </Card>
//               </Col>
//               <Col md={2}>
//                 <Card className='text-center border-0 bg-secondary bg-opacity-35 '>
//                   <CardBody className='p-3'>
//                     <CardTitle className='fs-6 text-secondary'>No Turnover</CardTitle>
//                     <h4 className='text-secondary'>{noTurnover}</h4>
//                     <small className='text-muted'>{((noTurnover / totalItems) * 100).toFixed(1)}%</small>
//                   </CardBody>
//                 </Card>
//               </Col>
//             </Row>
//           )}

//           {/* Overall Metrics */}
//           {data.length > 0 && (
//             <Card className='mb-4'>
//               <CardHeader>
//                 <h6 className='mb-0'>Overall Inventory Metrics</h6>
//               </CardHeader>
//               <CardBody>
//                 <Row>
//                   <Col md={4}>
//                     <div className='text-center'>
//                       <h4
//                         className={
//                           avgTurnoverRate >= 4 ? 'text-success' : avgTurnoverRate >= 2 ? 'text-warning' : 'text-danger'
//                         }
//                       >
//                         {formatTurnoverRate(avgTurnoverRate)}
//                       </h4>
//                       <p className='text-muted mb-0'>Average Turnover Rate</p>
//                     </div>
//                   </Col>
//                   <Col md={4}>
//                     <div className='text-center'>
//                       <h4 className='text-info'>{formatCurrency(totalCOGS)}</h4>
//                       <p className='text-muted mb-0'>Total COGS</p>
//                     </div>
//                   </Col>
//                   <Col md={4}>
//                     <div className='text-center'>
//                       <h4 className='text-primary'>{formatCurrency(totalAvgStock)}</h4>
//                       <p className='text-muted mb-0'>Average Stock Value</p>
//                     </div>
//                   </Col>
//                 </Row>
//               </CardBody>
//             </Card>
//           )}

//           {/* Turnover Distribution */}
//           {data.length > 0 && (
//             <Card className='mb-4'>
//               <CardHeader>
//                 <h6 className='mb-0'>Turnover Rate Distribution</h6>
//               </CardHeader>
//               <CardBody>
//                 <ProgressBar style={{ height: '25px' }}>
//                   <ProgressBar
//                     variant='success'
//                     now={(excellentTurnover / totalItems) * 100}
//                     key={1}
//                     label={`${excellentTurnover} Excellent`}
//                   />
//                   <ProgressBar
//                     variant='info'
//                     now={(goodTurnover / totalItems) * 100}
//                     key={2}
//                     label={`${goodTurnover} Good`}
//                   />
//                   <ProgressBar
//                     variant='warning'
//                     now={(averageTurnover / totalItems) * 100}
//                     key={3}
//                     label={`${averageTurnover} Average`}
//                   />
//                   <ProgressBar
//                     variant='danger'
//                     now={(slowTurnover / totalItems) * 100}
//                     key={4}
//                     label={`${slowTurnover} Slow`}
//                   />
//                   <ProgressBar
//                     variant='secondary'
//                     now={(noTurnover / totalItems) * 100}
//                     key={5}
//                     label={`${noTurnover} None`}
//                   />
//                 </ProgressBar>
//               </CardBody>
//             </Card>
//           )}

//           {loading ? (
//             <div className='text-center my-5'>
//               <Spinner animation='border' role='status'>
//                 <span className='visually-hidden'>Loading...</span>
//               </Spinner>
//               <p className='mt-2'>Loading inventory turnover data...</p>
//             </div>
//           ) : filteredData.length > 0 ? (
//             <div className='table-responsive'>
//               <Table striped bordered hover>
//                 <thead>
//                   <tr>
//                     <th>Item Code</th>
//                     <th>Item Name</th>
//                     <th>COGS</th>
//                     <th>Opening Stock</th>
//                     <th>Closing Stock</th>
//                     <th>Average Stock</th>
//                     <th>Turnover Rate</th>
//                     <th>Performance</th>
//                     <th>Efficiency</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredData.map((item, index) => {
//                     const performance = getTurnoverPerformance(item.turnoverRate);
//                     return (
//                       <tr key={`${item.itemId}-${index}`}>
//                         <td className='fw-bold'>{item.itemCode}</td>
//                         <td>
//                           <div>{item.itemName}</div>
//                           {item.itemName2 && <div className='text-muted small'>{item.itemName2}</div>}
//                         </td>
//                         <td className='text-danger'>{formatCurrency(item.costOfGoodsSold)}</td>
//                         <td>{formatCurrency(item.openingStockValue)}</td>
//                         <td>{formatCurrency(item.closingStockValue)}</td>
//                         <td className='fw-bold text-primary'>{formatCurrency(item.averageStockValue)}</td>
//                         <td>
//                           <Badge bg={getTurnoverBadgeColor(item.turnoverRate)}>
//                             {formatTurnoverRate(item.turnoverRate)}
//                           </Badge>
//                         </td>
//                         <td>
//                           <Badge bg={performance.badge}>{performance.category}</Badge>
//                         </td>
//                         <td>
//                           {item.turnoverRate >= 8 && <Badge bg='success'>Highly Efficient</Badge>}
//                           {item.turnoverRate >= 4 && item.turnoverRate < 8 && <Badge bg='info'>Efficient</Badge>}
//                           {item.turnoverRate >= 2 && item.turnoverRate < 4 && <Badge bg='warning'>Moderate</Badge>}
//                           {item.turnoverRate > 0 && item.turnoverRate < 2 && <Badge bg='danger'>Inefficient</Badge>}
//                           {item.turnoverRate === 0 && <Badge bg='secondary'>No Movement</Badge>}
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </Table>
//             </div>
//           ) : (
//             <div className='text-center py-5'>
//               <p>No data available. Set your filters and click "Load Report" to generate.</p>
//             </div>
//           )}
//         </CardBody>

//         {data.length > 0 && (
//           <CardFooter className='text-muted'>
//             <div className='row'>
//               <div className='col-md-6'>
//                 <small>
//                   <strong>Turnover Performance:</strong>{' '}
//                   <Badge bg='success' className='me-1'>
//                     Excellent (8+)
//                   </Badge>
//                   <Badge bg='info' className='me-1'>
//                     Good (4-7.99)
//                   </Badge>
//                   <Badge bg='warning' className='me-1'>
//                     Average (2-3.99)
//                   </Badge>
//                   <Badge bg='danger' className='me-1'>
//                     Slow (0.01-1.99)
//                   </Badge>
//                   <Badge bg='secondary' className='me-1'>
//                     No Turnover (0)
//                   </Badge>
//                 </small>
//               </div>
//               <div className='col-md-6 text-end'>
//                 <small>Report generated on {new Date().toLocaleString()}</small>
//               </div>
//             </div>
//           </CardFooter>
//         )}
//       </Card>
//     </div>
//   );
// };

// export default InventoryTurnoverReport;



import React, { useState } from 'react';
import {
  Table,
  Spinner,
  Form,
  Row,
  Col,
  Button,
  Alert,
  Badge,
  CardFooter,
  CardTitle,
  ProgressBar
} from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Card, CardBody, CardHeader } from '@components/card/card';
import { ntxAPI } from '@API/axiosNeatex';
import useGetItemsList from '@hooks/INV/MasterItems/useGetItemsList';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import type { APIResponse } from '@store/Shared/shared';
import Loading from '@components/Shared/Loader/Loading';

interface InventoryTurnover {
  itemId: string;
  itemCode: string;
  itemName: string;
  itemName2: string;
  costOfGoodsSold: number;
  openingStockValue: number;
  closingStockValue: number;
  averageStockValue: number;
  turnoverRate: number;
}

const InventoryTurnoverReport: React.FC = () => {
  const [data, setData] = useState<InventoryTurnover[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const { ItemsOptions, loading: loading1, error: error1 } = useGetItemsList();
  const [itemId, setItemId] = useState<string | null>('');
  const { t, i18n } = useTranslation();

  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([null, null]);
  const [startDate, endDate] = dateRange;

  const [turnoverFilter, setTurnoverFilter] = useState<string>('all');
  const [performanceFilter, setPerformanceFilter] = useState<string>('all');

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await ntxAPI.get<APIResponse<InventoryTurnover[]>>(`InventoryReports/turnover`, {
        params: {
          ItemId: itemId,
          StartDate: startDate,
          EndDate: endDate
        }
      });

      if (data.succeeded === true) {
        setData(data.data);
      } else {
        setError(data instanceof Error ? data.message : t('UnknownError'));
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : t('UnknownError'));
    } finally {
      setLoading(false);
    }
  };

  const resetFilters = () => {
    setItemId(null);
    setDateRange([null, null]);
    setTurnoverFilter('all');
    setPerformanceFilter('all');
  };

  const formatCurrency = (amount: number): string => {
    return new Intl.NumberFormat('en-US').format(amount);
  };

  const formatTurnoverRate = (rate: number): string => {
    return rate.toFixed(2);
  };

  // Get turnover performance category
  const getTurnoverPerformance = (turnoverRate: number) => {
    if (turnoverRate === 0) return { 
      category: i18n.language === 'en' ? 'No Turnover' : 'لا يوجد دوران', 
      color: 'secondary', 
      badge: 'secondary' 
    };
    if (turnoverRate >= 8) return { 
      category: i18n.language === 'en' ? 'Excellent' : 'ممتاز', 
      color: 'success', 
      badge: 'success' 
    };
    if (turnoverRate >= 4) return { 
      category: i18n.language === 'en' ? 'Good' : 'جيد', 
      color: 'info', 
      badge: 'primary' 
    };
    if (turnoverRate >= 2) return { 
      category: i18n.language === 'en' ? 'Average' : 'متوسط', 
      color: 'warning', 
      badge: 'warning' 
    };
    return { 
      category: i18n.language === 'en' ? 'Slow' : 'بطيء', 
      color: 'danger', 
      badge: 'danger' 
    };
  };

  // Get turnover badge color
  const getTurnoverBadgeColor = (turnoverRate: number) => {
    if (turnoverRate === 0) return 'secondary';
    if (turnoverRate >= 8) return 'success';
    if (turnoverRate >= 4) return 'info';
    if (turnoverRate >= 2) return 'warning';
    return 'danger';
  };

  // Calculate turnover statistics
  const calculateTurnoverStats = () => {
    const totalItems = data.length;
    const excellentTurnover = data.filter(item => item.turnoverRate >= 8).length;
    const goodTurnover = data.filter(item => item.turnoverRate >= 4 && item.turnoverRate < 8).length;
    const averageTurnover = data.filter(item => item.turnoverRate >= 2 && item.turnoverRate < 4).length;
    const slowTurnover = data.filter(item => item.turnoverRate > 0 && item.turnoverRate < 2).length;
    const noTurnover = data.filter(item => item.turnoverRate === 0).length;

    const totalCOGS = data.reduce((sum, item) => sum + item.costOfGoodsSold, 0);
    const totalAvgStock = data.reduce((sum, item) => sum + item.averageStockValue, 0);
    const avgTurnoverRate = totalItems > 0 ? data.reduce((sum, item) => sum + item.turnoverRate, 0) / totalItems : 0;

    return {
      totalItems,
      excellentTurnover,
      goodTurnover,
      averageTurnover,
      slowTurnover,
      noTurnover,
      totalCOGS,
      totalAvgStock,
      avgTurnoverRate
    };
  };

  // Filter data based on turnover and performance
  const filteredData = data.filter(item => {
    if (turnoverFilter === 'excellent' && item.turnoverRate < 8) return false;
    if (turnoverFilter === 'good' && (item.turnoverRate < 4 || item.turnoverRate >= 8)) return false;
    if (turnoverFilter === 'average' && (item.turnoverRate < 2 || item.turnoverRate >= 4)) return false;
    if (turnoverFilter === 'slow' && (item.turnoverRate >= 2 || item.turnoverRate === 0)) return false;
    if (turnoverFilter === 'none' && item.turnoverRate !== 0) return false;

    if (performanceFilter === 'highValue' && item.averageStockValue < 1000) return false;
    if (performanceFilter === 'lowValue' && item.averageStockValue >= 1000) return false;

    return true;
  });

  const {
    totalItems,
    excellentTurnover,
    goodTurnover,
    averageTurnover,
    slowTurnover,
    noTurnover,
    totalCOGS,
    totalAvgStock,
    avgTurnoverRate
  } = calculateTurnoverStats();

 
  return (
    <div className='container mt-4' >
      <Card>
        <CardHeader className='d-flex justify-content-between align-items-center'>
          <h5 className='mb-0'>
            {i18n.language === 'en' ? 'Inventory Turnover Report' : 'تقرير دوران المخزون'}
          </h5>
          {data.length > 0 && (
            <div>
              <span className='me-2'>
                {i18n.language === 'en'
                  ? `Showing: ${filteredData.length} of ${data.length} items`
                  : `عرض: ${filteredData.length} من ${data.length} عنصر`}
              </span>
            </div>
          )}
        </CardHeader>

        <CardBody>
          {error && (
            <Alert variant='danger' className='mb-4'>
              {i18n.language === 'en' ? 'Error loading data:' : 'خطأ في تحميل البيانات:'} {error}
            </Alert>
          )}

          <Card className='mb-4'>
            <CardHeader>{i18n.language === 'en' ? 'Filters' : 'الفلاتر'}</CardHeader>
            <Loading loading={loading1} error={error1}>
              <CardBody>
                <Form>
                  <Row className='g-3'>
                    <Col md={3}>
                      <Form.Group>
                        <Form.Label>{t('itemName')}</Form.Label>
                        <Select
                          classNamePrefix='react-select'
                          isSearchable
                          isClearable
                          options={ItemsOptions}
                          onChange={(option: any) => setItemId(option?.value || null)}
                          value={ItemsOptions.find(f => f.value === itemId)}
                          placeholder={t('Choose')}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                          }}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={3}>
                      <Form.Group>
                        <Form.Label>{i18n.language === 'en' ? 'Date Range' : 'نطاق التاريخ'}</Form.Label>
                        <DatePicker
                          selectsRange={true}
                          startDate={startDate}
                          endDate={endDate}
                          onChange={update => setDateRange(update)}
                          isClearable={true}
                          className='form-control text-center'
                          placeholderText={i18n.language === 'en' ? 'Select date range' : 'اختر نطاق التاريخ'}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={3}>
                      <Form.Group controlId='turnoverFilter'>
                        <Form.Label>
                          {i18n.language === 'en' ? 'Turnover Rate' : 'معدل الدوران'}
                        </Form.Label>
                        <Form.Select value={turnoverFilter} onChange={e => setTurnoverFilter(e.target.value)}>
                          <option value='all'>
                            {i18n.language === 'en' ? 'All Turnover Rates' : 'جميع معدلات الدوران'}
                          </option>
                          <option value='excellent'>
                            {i18n.language === 'en' ? 'Excellent (8+)' : 'ممتاز (8+)'}
                          </option>
                          <option value='good'>
                            {i18n.language === 'en' ? 'Good (4-7.99)' : 'جيد (4-7.99)'}
                          </option>
                          <option value='average'>
                            {i18n.language === 'en' ? 'Average (2-3.99)' : 'متوسط (2-3.99)'}
                          </option>
                          <option value='slow'>
                            {i18n.language === 'en' ? 'Slow (0.01-1.99)' : 'بطيء (0.01-1.99)'}
                          </option>
                          <option value='none'>
                            {i18n.language === 'en' ? 'No Turnover (0)' : 'لا يوجد دوران (0)'}
                          </option>
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col md={3}>
                      <Form.Group controlId='performanceFilter'>
                        <Form.Label>
                          {i18n.language === 'en' ? 'Stock Value' : 'قيمة المخزون'}
                        </Form.Label>
                        <Form.Select value={performanceFilter} onChange={e => setPerformanceFilter(e.target.value)}>
                          <option value='all'>
                            {i18n.language === 'en' ? 'All Stock Values' : 'جميع قيم المخزون'}
                          </option>
                          <option value='highValue'>
                            {i18n.language === 'en' ? 'High Value (≥ 1,000)' : 'قيمة عالية (≥ 1,000)'}
                          </option>
                          <option value='lowValue'>
                            {i18n.language === 'en' ? 'Low Value (< 1,000)' : 'قيمة منخفضة (< 1,000)'}
                          </option>
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col xs={12} className={`text-end  `}>
                      <Button variant='secondary' onClick={resetFilters} className='me-2'>
                        {i18n.language === 'en' ? 'Reset Filters' : 'إعادة تعيين الفلاتر'}
                      </Button>
                      <Button variant='primary' onClick={fetchData} disabled={loading}>
                        {loading ? (
                          <>
                            <Spinner
                              as='span'
                              animation='border'
                              size='sm'
                              role='status'
                              aria-hidden='true'
                              className='me-2'
                            />
                            {i18n.language === 'en' ? 'Loading...' : 'جاري التحميل...'}
                          </>
                        ) : i18n.language === 'en' ? (
                          'Load Report'
                        ) : (
                          'تحميل التقرير'
                        )}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Loading>
          </Card>

          {/* Turnover Summary */}
          {data.length > 0 && (
            <Row className='mb-4'>
              <Col md={2}>
                <Card className='text-center border-0 bg-secondary bg-opacity-35 '>
                  <CardBody className='p-3'>
                    <CardTitle className='fs-6 text-primary'>
                      {i18n.language === 'en' ? 'Total Items' : 'إجمالي الأصناف'}
                    </CardTitle>
                    <h4 className='text-primary'>{totalItems}</h4>
                  </CardBody>
                </Card>
              </Col>
              <Col md={2}>
                <Card className='text-center border-0 bg-secondary bg-opacity-35 '>
                  <CardBody className='p-3'>
                    <CardTitle className='fs-6 text-success'>
                      {i18n.language === 'en' ? 'Excellent' : 'ممتاز'}
                    </CardTitle>
                    <h4 className='text-success'>{excellentTurnover}</h4>
                    <small className='text-muted'>{((excellentTurnover / totalItems) * 100).toFixed(1)}%</small>
                  </CardBody>
                </Card>
              </Col>
              <Col md={2}>
                <Card className='text-center border-0 bg-secondary bg-opacity-35 '>
                  <CardBody className='p-3'>
                    <CardTitle className='fs-6 text-info'>
                      {i18n.language === 'en' ? 'Good' : 'جيد'}
                    </CardTitle>
                    <h4 className='text-info'>{goodTurnover}</h4>
                    <small className='text-muted'>{((goodTurnover / totalItems) * 100).toFixed(1)}%</small>
                  </CardBody>
                </Card>
              </Col>
              <Col md={2}>
                <Card className='text-center border-0 bg-secondary bg-opacity-35 '>
                  <CardBody className='p-3'>
                    <CardTitle className='fs-6 text-warning'>
                      {i18n.language === 'en' ? 'Average' : 'متوسط'}
                    </CardTitle>
                    <h4 className='text-warning'>{averageTurnover}</h4>
                    <small className='text-muted'>{((averageTurnover / totalItems) * 100).toFixed(1)}%</small>
                  </CardBody>
                </Card>
              </Col>
              <Col md={2}>
                <Card className='text-center border-0 bg-secondary bg-opacity-35 '>
                  <CardBody className='p-3'>
                    <CardTitle className='fs-6 text-danger'>
                      {i18n.language === 'en' ? 'Slow' : 'بطيء'}
                    </CardTitle>
                    <h4 className='text-danger'>{slowTurnover}</h4>
                    <small className='text-muted'>{((slowTurnover / totalItems) * 100).toFixed(1)}%</small>
                  </CardBody>
                </Card>
              </Col>
              <Col md={2}>
                <Card className='text-center border-0 bg-secondary bg-opacity-35 '>
                  <CardBody className='p-3'>
                    <CardTitle className='fs-6 text-secondary'>
                      {i18n.language === 'en' ? 'No Turnover' : 'لا يوجد دوران'}
                    </CardTitle>
                    <h4 className='text-secondary'>{noTurnover}</h4>
                    <small className='text-muted'>{((noTurnover / totalItems) * 100).toFixed(1)}%</small>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}

          {/* Overall Metrics */}
          {data.length > 0 && (
            <Card className='mb-4'>
              <CardHeader>
                <h6 className='mb-0'>
                  {i18n.language === 'en' ? 'Overall Inventory Metrics' : 'مؤشرات المخزون الإجمالية'}
                </h6>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col md={4}>
                    <div className='text-center'>
                      <h4
                        className={
                          avgTurnoverRate >= 4 ? 'text-success' : avgTurnoverRate >= 2 ? 'text-warning' : 'text-danger'
                        }
                      >
                        {formatTurnoverRate(avgTurnoverRate)}
                      </h4>
                      <p className='text-muted mb-0'>
                        {i18n.language === 'en' ? 'Average Turnover Rate' : 'متوسط معدل الدوران'}
                      </p>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className='text-center'>
                      <h4 className='text-info'>{formatCurrency(totalCOGS)}</h4>
                      <p className='text-muted mb-0'>
                        {i18n.language === 'en' ? 'Total COGS' : 'إجمالي تكلفة البضاعة المباعة'}
                      </p>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className='text-center'>
                      <h4 className='text-primary'>{formatCurrency(totalAvgStock)}</h4>
                      <p className='text-muted mb-0'>
                        {i18n.language === 'en' ? 'Average Stock Value' : 'متوسط قيمة المخزون'}
                      </p>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          )}

          {/* Turnover Distribution */}
          {data.length > 0 && (
            <Card className='mb-4'>
              <CardHeader>
                <h6 className='mb-0'>
                  {i18n.language === 'en' ? 'Turnover Rate Distribution' : 'توزيع معدلات الدوران'}
                </h6>
              </CardHeader>
              <CardBody>
                <ProgressBar style={{ height: '25px' }}>
                  <ProgressBar
                    variant='success'
                    now={(excellentTurnover / totalItems) * 100}
                    key={1}
                    label={`${excellentTurnover} ${i18n.language === 'en' ? 'Excellent' : 'ممتاز'}`}
                  />
                  <ProgressBar
                    variant='info'
                    now={(goodTurnover / totalItems) * 100}
                    key={2}
                    label={`${goodTurnover} ${i18n.language === 'en' ? 'Good' : 'جيد'}`}
                  />
                  <ProgressBar
                    variant='warning'
                    now={(averageTurnover / totalItems) * 100}
                    key={3}
                    label={`${averageTurnover} ${i18n.language === 'en' ? 'Average' : 'متوسط'}`}
                  />
                  <ProgressBar
                    variant='danger'
                    now={(slowTurnover / totalItems) * 100}
                    key={4}
                    label={`${slowTurnover} ${i18n.language === 'en' ? 'Slow' : 'بطيء'}`}
                  />
                  <ProgressBar
                    variant='secondary'
                    now={(noTurnover / totalItems) * 100}
                    key={5}
                    label={`${noTurnover} ${i18n.language === 'en' ? 'None' : 'لا يوجد'}`}
                  />
                </ProgressBar>
              </CardBody>
            </Card>
          )}

          {loading ? (
            <div className='text-center my-5'>
              <Spinner animation='border' role='status'>
                <span className='visually-hidden'>
                  {i18n.language === 'en' ? 'Loading...' : 'جاري التحميل...'}
                </span>
              </Spinner>
              <p className='mt-2'>
                {i18n.language === 'en' 
                  ? 'Loading inventory turnover data...' 
                  : 'جاري تحميل بيانات دوران المخزون...'}
              </p>
            </div>
          ) : filteredData.length > 0 ? (
            <div className='table-responsive'>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>{i18n.language === 'en' ? 'Item Code' : 'كود الصنف'}</th>
                    <th>{i18n.language === 'en' ? 'Item Name' : 'اسم الصنف'}</th>
                    <th>{i18n.language === 'en' ? 'COGS' : 'تكلفة البضاعة المباعة'}</th>
                    <th>{i18n.language === 'en' ? 'Opening Stock' : 'المخزون الافتتاحي'}</th>
                    <th>{i18n.language === 'en' ? 'Closing Stock' : 'المخزون الختامي'}</th>
                    <th>{i18n.language === 'en' ? 'Average Stock' : 'متوسط المخزون'}</th>
                    <th>{i18n.language === 'en' ? 'Turnover Rate' : 'معدل الدوران'}</th>
                    <th>{i18n.language === 'en' ? 'Performance' : 'الأداء'}</th>
                    <th>{i18n.language === 'en' ? 'Efficiency' : 'الكفاءة'}</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.map((item, index) => {
                    const performance = getTurnoverPerformance(item.turnoverRate);
                    
                    // Translate efficiency levels
                    const getEfficiencyText = () => {
                      if (item.turnoverRate >= 8) return i18n.language === 'en' ? 'Highly Efficient' : 'فائق الكفاءة';
                      if (item.turnoverRate >= 4 && item.turnoverRate < 8) return i18n.language === 'en' ? 'Efficient' : 'كفؤ';
                      if (item.turnoverRate >= 2 && item.turnoverRate < 4) return i18n.language === 'en' ? 'Moderate' : 'متوسط';
                      if (item.turnoverRate > 0 && item.turnoverRate < 2) return i18n.language === 'en' ? 'Inefficient' : 'غير كفؤ';
                      return i18n.language === 'en' ? 'No Movement' : 'لا يوجد حركة';
                    };

                    const getEfficiencyBadgeColor = () => {
                      if (item.turnoverRate >= 8) return 'success';
                      if (item.turnoverRate >= 4 && item.turnoverRate < 8) return 'info';
                      if (item.turnoverRate >= 2 && item.turnoverRate < 4) return 'warning';
                      if (item.turnoverRate > 0 && item.turnoverRate < 2) return 'danger';
                      return 'secondary';
                    };

                    return (
                      <tr key={`${item.itemId}-${index}`}>
                        <td className='fw-bold'>{item.itemCode}</td>
                        <td>
                          <div>{i18n.language === 'en' ? item.itemName : item.itemName2 || item.itemName}</div>
                          {item.itemName2 && (
                            <div className='text-muted small'>
                              {i18n.language === 'en' ? item.itemName2 : item.itemName}
                            </div>
                          )}
                        </td>
                        <td className='text-danger'>{formatCurrency(item.costOfGoodsSold)}</td>
                        <td>{formatCurrency(item.openingStockValue)}</td>
                        <td>{formatCurrency(item.closingStockValue)}</td>
                        <td className='fw-bold text-primary'>{formatCurrency(item.averageStockValue)}</td>
                        <td>
                          <Badge bg={getTurnoverBadgeColor(item.turnoverRate)}>
                            {formatTurnoverRate(item.turnoverRate)}
                          </Badge>
                        </td>
                        <td>
                          <Badge bg={performance.badge}>{performance.category}</Badge>
                        </td>
                        <td>
                          <Badge bg={getEfficiencyBadgeColor()}>
                            {getEfficiencyText()}
                          </Badge>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          ) : (
            <div className='text-center py-5'>
              <p>
                {i18n.language === 'en'
                  ? 'No data available. Set your filters and click "Load Report" to generate.'
                  : 'لا توجد بيانات متاحة. قم بتعيين الفلاتر الخاصة بك وانقر على "تحميل التقرير" لإنشائه.'}
              </p>
            </div>
          )}
        </CardBody>

        {data.length > 0 && (
          <CardFooter className='text-muted'>
            <div className='row'>
              <div className='col-md-6'>
                <small>
                  <strong>
                    {i18n.language === 'en' ? 'Turnover Performance:' : 'أداء الدوران:'}
                  </strong>{' '}
                  <Badge bg='success' className='me-1'>
                    {i18n.language === 'en' ? 'Excellent (8+)' : 'ممتاز (8+)'}
                  </Badge>
                  <Badge bg='info' className='me-1'>
                    {i18n.language === 'en' ? 'Good (4-7.99)' : 'جيد (4-7.99)'}
                  </Badge>
                  <Badge bg='warning' className='me-1'>
                    {i18n.language === 'en' ? 'Average (2-3.99)' : 'متوسط (2-3.99)'}
                  </Badge>
                  <Badge bg='danger' className='me-1'>
                    {i18n.language === 'en' ? 'Slow (0.01-1.99)' : 'بطيء (0.01-1.99)'}
                  </Badge>
                  <Badge bg='secondary' className='me-1'>
                    {i18n.language === 'en' ? 'No Turnover (0)' : 'لا يوجد دوران (0)'}
                  </Badge>
                </small>
              </div>
              <div className={`col-md-6 text-end `}>
                <small>
                  {i18n.language === 'en'
                    ? `Report generated on ${new Date().toLocaleString()}`
                    : `تم إنشاء التقرير في ${new Date().toLocaleString()}`}
                </small>
              </div>
            </div>
          </CardFooter>
        )}
      </Card>
    </div>
  );
};

export default InventoryTurnoverReport;
